import React from 'react';
import { graphql, usePreloadedQuery, type EntryPointProps } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { JswExpandableProjectQuery } from '@atlassian/jira-relay/src/__generated__/JswExpandableProjectQuery.graphql';
import { JswBoards } from './jsw-boards/JswBoards.tsx';

type Queries = { projects: JswExpandableProjectQuery };

export function JswExpandableProjectQuery({
	queries: { projects },
}: EntryPointProps<Queries, {}, EntryPointRouteParams, {}>): React.JSX.Element {
	const data = usePreloadedQuery<JswExpandableProjectQuery>(
		graphql`
			query JswExpandableProjectQuery($cloudId: ID!, $projectKey: String!, $noOfBoardsToFetch: Int!)
			@preloadable {
				jira @required(action: THROW) {
					jiraProjectByKey(cloudId: $cloudId, key: $projectKey) @required(action: THROW) {
						...JswBoards @arguments(noOfBoardsToFetch: $noOfBoardsToFetch)
					}
				}
			}
		`,
		projects,
	);

	return <JswBoards queryRef={data.jira.jiraProjectByKey} />;
}
